<template>
  <svg width="50" height="50" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <!-- Brain -->
    <path d="M50 20 C30 20, 30 60, 50 60 C70 60, 70 20, 50 20" stroke="black" stroke-width="2" fill="transparent"/>

    <!-- Neural Pathways -->
    <circle cx="40" cy="30" r="3" fill="black">
      <animate attributeName="cy" values="30;40;30" dur="1s" repeatCount="indefinite"/>
    </circle>
    <circle cx="60" cy="40" r="3" fill="black">
      <animate attributeName="cy" values="40;30;40" dur="1s" repeatCount="indefinite"/>
    </circle>
  </svg>
</template>
